import { MessageState } from 'Modules/Communication/shared/models/Inbox'
import { messageStateToInboxSectionEnum } from 'Modules/Communication/shared/util/messageStateHelper'
import { SystemState } from './types'

export const getEmails = (state: SystemState) => state.communication.emails

export const getEmailsFilters = (state: SystemState) =>
  state.communication.emails.filters

export const getEmailsSection = (state: SystemState) =>
  state.communication.emails.filters.queryStatus

export const getEmailsLabel = (state: SystemState) =>
  state.communication.emails.filters.labelId

export const getEmailsMarkedForActions = (state: SystemState) =>
  state.communication.emails.marked

export const getEmailFromEmailsById = (id: string) => (state: SystemState) =>
  getEmails(state)?.data?.result.find((email) => email.id === id)

export const isEmailMarkedForAction = (id: string) => (state: SystemState) =>
  state.communication.emails.marked.includes(id)

export const getEmail = (state: SystemState) => state.communication.emails.email

export const getCurrentEmail = (state: SystemState) =>
  state.communication.emails.email.current

export const getSingleListActionId = (state: SystemState) =>
  state.communication.emails.singleListActionId

export const getEmailStatistics = (state: SystemState) =>
  state.communication.emails.statistics

export const getJunkMailState = (state: SystemState) =>
  state.communication.emails.junkmail

export const getCurrentEmailState =
  (currentId?: string) => (state: SystemState) => {
    const email = getEmail(state)
    if (!currentId) return null
    if (!email.current) return null

    const currentState = getEmail(state).data?.state || MessageState.Processed
    return messageStateToInboxSectionEnum(currentState)
  }
